// Central API configuration
// Automatically switches between development and production based on NODE_ENV

// Environment-based API URLs
const API_URLS = {
  development: 'http://127.0.0.1:8000',
  production: 'https://api.traklog.app'
};

// Use environment variable if available, otherwise fall back to environment-based selection
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 
                            API_URLS[process.env.NODE_ENV] || 
                            API_URLS.development;

// Export for use in other components
export default API_BASE_URL;